import { Component, OnInit } from '@angular/core';

import { RolesService } from 'src/app/services/roles.service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-listar-roles',
  templateUrl: './listar-roles.component.html',
  styleUrls: ['./listar-roles.component.css']
})
export class ListarRolesComponent implements OnInit {

  titulo = 'Consulta de roles';
  mensajeDesactivacion = 'Al desactivar un rol los usuarios que lo tenían asignado perderán los permisos ' +
                         'relacionados con el rol, sin embargo las configuraciones de rol se conservarán y ' +
                         'si en el futuro se reactiva los usuarios recuperarán los permisos del rol';
  mensajeActivacion = 'Al reactivar un rol, éste será restablecido para todos los usuarios que lo tenían ' +
                      'asignado, quienes podrán nuevamente usarlo en las mismas funcionalidades que lo ' +
                      'tenían en el momento de la inactivación del rol';
  errorAccion = 'La acción solicitada no se pudo completar';
  rolVacio = 'El nombre del rol no puede estar vacio';
  rolExistente = 'El nombre del rol ya existe';
  errorEdicion = 'El rol no pudo ser editado';
  errorCreacion = 'El rol no pudo ser creado';
  roles:any = [];
  //rol: Roles | undefined;
  rol:any = {
    idRole:'',
    description: '',
    displayName: '',
    value: '',
    isEnabled : false
  }
  pagina = 1;
  dato : string | undefined;
  mostrar = false;
  nuevoNombre: string | undefined;
  nuevoRol: string | undefined;
  respuesta:any

  constructor(private rolesService: RolesService) { }

  ngOnInit(): void {
    this.cargarRoles();

    $("#cancel").on("click", function() {
      $("#caja").val('');
    });
  }

  cargarRoles(): void{
    this.rolesService.traerRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.roles = this.respuesta.data;
      console.log(this.roles)
    });
  }

  borrar(): void{
    this.cargarRoles();
  }

  buscar(texto: string): void{
    this.rolesService.traerRol(texto)
    .subscribe(resp => {
      this.respuesta = resp;
      this.roles = this.respuesta.data;
    });
  }

  mostrarBotones(codigo: string, nombre: string): void{
    this.dato = codigo;
    this.nuevoNombre = nombre.trim();
  }

  botonCancelar(): void{
    this.dato = '';
  }

  botonesCrearRol(): void{
    this.mostrar = true;
  }

  cancelarRol(): void{
    this.mostrar = false;
  }

  desactivarRol(rol: any): void{
    this.rol = rol
    this.rol.isEnabled = false
    this.ventanaEmergenteWarning(this.mensajeDesactivacion)
    .then(resp => {
      if (resp.value) {
        this.rolesService.actualizarRol(rol)
        .subscribe(rta => {
          if (rta.data) {
            this.ventanaEmergenteExito();
            this.cargarRoles();
          } else {
            this.ventanaEmergenteError(this.errorAccion);
          }
        });
      }
    });
  }

  activarRol(rol: any): void{
    this.rol = rol
    this.rol.isEnabled = true
    this.ventanaEmergenteWarning(this.mensajeActivacion)
    .then(resp => {
      if (resp.value) {
        this.rolesService.actualizarRol(rol)
        .subscribe(rta => {
          if (rta.data) {
            this.ventanaEmergenteExito();
            this.cargarRoles();
          } else {
            this.ventanaEmergenteError(this.errorAccion);
          }
        });
      }
    });
  }

  editarRol(id: string, nombre: string): void{
    if (nombre == "") {
      this.ventanaEmergenteError(this.rolVacio);
    } else {
      this.rolesService.revisarRol(nombre)
      .subscribe(resp => {
        if (resp.count > 0) {
          this.ventanaEmergenteError(this.rolExistente);
        } else {
          this.rol = {
            idRole:id,
            description: nombre,
            displayName: nombre,
            value: nombre,
            isEnabled: true
          }
          console.log(this.rol)
          this.rolesService.actualizarRol(this.rol)
          .subscribe(resp => {
            if (resp.data) {
              this.ventanaEmergenteExito();
              this.dato = '';
              this.cargarRoles();
            } else {
              this.ventanaEmergenteError(this.errorEdicion);
            }
          });
        }
      });
    }
  }

  crearRol(nombre: string): void{
    if (nombre == "" || nombre == undefined) {
      this.ventanaEmergenteError(this.rolVacio);
    } else {
      this.rolesService.revisarRol(nombre)
      .subscribe(resp => {
        if (resp.count > 0) {
          this.ventanaEmergenteError(this.rolExistente);
        } else {
          this.rol = {
            description: nombre,
            displayName: nombre,
            value: nombre,
            isEnabled:true
          }
          this.rolesService.crearRol(this.rol)
          .subscribe(resp => {
            if (resp.data) {
              this.ventanaEmergenteExito();
              this.mostrar = false;
              this.cargarRoles();
            } else {
              this.ventanaEmergenteError(this.errorCreacion);
            }
          });
        }
      });
    }
  }

  ventanaEmergenteWarning(mensaje: string): Promise<SweetAlertResult>{
    let respuesta =
    Swal.fire({
      html: `${ mensaje }` +
            '<h4 class="text-warning fw-bold mt-3">¿Desea continuar?</h4>',
      iconHtml: '<img src="assets/img/warning.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });
    return respuesta;
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: mensaje,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }
}
